const styles = {
  picker: {
    width: "100% !important",
    marginTop: "1.6rem",
  },
  addColor: {
    width: "100%",
    padding: "0.5rem",
    marginTop: "0.8rem",
    fontSize: "1.5rem"
  },
  colorNameInput: {
    width: "100%",
    height: "60px"
  }
};

export default styles;